import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 14,
	viewBox: "0 0 24 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_352_79026)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M1.93612 11.1976L12.0039 1.80103L14.1252 3.78092L4.05744 13.1775L1.93612 11.1976Z",
			fill: "black"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M19.9506 13.1776L9.88281 3.78101L12.0041 1.80111L22.0719 11.1977L19.9506 13.1776Z",
			fill: "black"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_352_79026",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 24,
			fill: "white",
			transform: "translate(24) rotate(90)"
		})
	}) })]
});
export default SvgArrowUp;
